"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class MessageBar extends fmko_ts_common_1.Widget {
    constructor() {
        super();
        this.messages = {};
        this.element = document.createElement("div");
        this.element.classList.add("message-bar", "flex-col");
    }
    addMessage(message) {
        if (this.hasMessage(message)) {
            return;
        }
        const icon = this.getIcon();
        const label = document.createElement("label");
        label.textContent = message;
        const messageContainer = document.createElement("div");
        messageContainer.classList.add("message-bar-message", "flex-row");
        messageContainer.appendChild(icon.element);
        messageContainer.appendChild(label);
        this.messages[message] = messageContainer;
        this.add(messageContainer);
        this.updateVisibility();
    }
    removeMessage(message) {
        if (!this.hasMessage(message)) {
            return;
        }
        this.remove(this.messages[message]);
        delete this.messages[message];
        this.updateVisibility();
    }
    removeAllMessages() {
        this.clearHTMLChildren();
        this.messages = {};
        this.updateVisibility();
    }
    hasMessage(message) {
        return this.messages[message] !== undefined;
    }
    updateVisibility() {
        const hasMessages = Object.values(this.messages).length > 0;
        this.setVisible(hasMessages);
    }
}
exports.default = MessageBar;
//# sourceMappingURL=MessageBar.js.map